import {Component, inject, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatExpansionModule} from '@angular/material/expansion';
import {RouterLink, RouterLinkActive, Router} from '@angular/router';
import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import { IVerticalMenu } from '../shared/IVerticalMenu.interface';
import {InvoicingClientService} from '../invoicing-client.service';
import {MatTooltipModule} from '@angular/material/tooltip';

@Component({
  selector: 'app-invoicing-module-menu',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    RouterLink,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    RouterLinkActive,
    MatTooltipModule
  ],
  templateUrl: './invoicing-module-menu.component.html',
  styleUrls: ['./invoicing-module-menu.component.scss'],
})
export class InvoicingModuleMenuComponent implements OnInit {

  @Input()
  menu!: IVerticalMenu[];

  selectedIndex: number | null = null;
  expandedNestedMenu: string | null = null;
  public clientName!: string;
  protected clientId: number;

  private readonly router = inject(Router);
  private readonly invoicingClientService = inject(InvoicingClientService);

  ngOnInit() {
    this.clientName = this.invoicingClientService.invoicingClient?.client_name;
    this.clientId = this.invoicingClientService.invoicingClient?.clientId
  }

  onStepChange(index: number, panel: any): void {
    this.selectedIndex = index;
  }

  onSubStepClick(stepIndex: number, subStepName: string, event: MouseEvent): void {
    event.stopPropagation();
    // Keep the parent panel expanded and selected
    this.selectedIndex = stepIndex;
  }

  toggleNestedMenu(menuName: string): void {
    this.expandedNestedMenu = this.expandedNestedMenu === menuName ? null : menuName;
  }

  isActiveRoute(route: string): boolean {
    return this.router.url === route;
  }

  getMatIcon(iconName: string): string {
    // Map custom icon names to Material icons
    const iconMapping: { [key: string]: string } = {
      'invoice': 'description',
      'sales': 'point_of_sale',
      'customer_transactions': 'receipt_long',
      'default_setting': 'settings',
      'home': 'home',
      'quotations': 'request_quote',
      'receipts': 'receipt',
      'expenses': 'payments',
      'expenses_2': 'money_off',
      'vendor': 'business',
      'expenses_accounts': 'account_balance',
      'reports': 'analytics',
      'reports_2': 'bar_chart',
      'dashboards': 'dashboard',
      'accounting_log': 'history',
      'setup': 'build',
      'security': 'security',
      'my_details': 'person',
      'role': 'admin_panel_settings',
      'users': 'people',
      'user_log': 'event_note',
      'add': 'add'
    };

    return iconMapping[iconName] || 'folder';
  }
}
